import EnglishPage from './EnglishPage'
export default EnglishPage